import { QuestionType } from '@repo/types/enums/questionType';
import { infer as Infer, z } from 'zod';

import { questionBaseSchema } from './question.schema';

export const questionVoiceRecordSchema = questionBaseSchema.extend({
  type: z.literal(QuestionType.VOICE),
  manualCheck: z.boolean(),
  answer: z.string().nullish(),
});

export type QuestionVoiceRecordSchema = Infer<typeof questionVoiceRecordSchema>;
